<template>
    <div>
        <p
            v-for="w in CWarehouse"
            :key="w">
            <!--
              <span class="font-bold">
              Kho
              </span> -
            -->

            {{ w.nodeLocationName }}
        </p>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const CWarehouse = computed(() => {
  const { positions } = params?.value?.data || {}
  return positions?.filter((item: any) => {
    if (item.nodeTypeName === 'Kho') {
      return true
    }

    return false
  })
})
</script>

<style scoped></style>
